import { RADIO_BUTTON_VALUE_STANDARD_SERVICE } from "./constants";

const debounce = (func, wait, immediate) => {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const deepCloneObj = (oldObj) => {
  let obj = null;

  obj = JSON.parse(JSON.stringify(oldObj));
  // try {
  // } catch (e) {
  //   console.error(e)
  // }

  return obj;
};

const incomingStudyMapper = (incomingObj) => {
  const dereferencedObj = deepCloneObj(incomingObj);
  const studyMode = dereferencedObj.studyModel;
  const studyModel = studyModelFactory(studyMode);
  studyModel.name = dereferencedObj.surveyParamaters.name;
  studyModel.language = dereferencedObj.surveyParamaters.language;
  studyModel.meta.id = dereferencedObj.surveyParamaters.id;
  studyModel.hidden = dereferencedObj.hidden;
  studyModel.questions = studyModel.questions.map((question, i) => {
    const incomingQuestionObj = dereferencedObj.surveyParamaters.questions[i];
    if (incomingQuestionObj) {
      question.text = incomingQuestionObj.question;
      question.answers = question.answers.map((answer, j) => {
        if (incomingQuestionObj.answers && incomingQuestionObj.answers[j]) {
          answer.text = incomingQuestionObj.answers[j].answer;
        }
        return answer;
      });
    }
    return question;
  });
  if (dereferencedObj.surveyParamaters.segmentQuestions) {
    studyModel.segmentQuestions = dereferencedObj.surveyParamaters.segmentQuestions;
  }
  if (dereferencedObj.prelimQuestion) {
    studyModel.additionalClassificationQuestion.question.text =
      dereferencedObj.prelimQuestion.question;
    studyModel.additionalClassificationQuestion.answers.text =
      dereferencedObj.prelimQuestion.answers.map((answer) => {
        return {
          text: answer,
        };
      });
  }
  studyModel.asksLinker = dereferencedObj.surveyParamaters.asksLinker;
  studyModel.openEndedQuestion = dereferencedObj.surveyParamaters.optionalQuestion;
  studyModel.preOptionalQuestion = dereferencedObj.surveyParamaters.optionalPreQuestion;
  studyModel.presentationMedia = {
    preMediaQuestions: dereferencedObj.surveyParamaters.preMediaQuestions,
    prePresentation: dereferencedObj.surveyParamaters.prePresentation,
  };
  studyModel.postPresentationMedia = {
    postMediaQuestions: dereferencedObj.surveyParamaters.postMediaQuestions,
    postPresentation: dereferencedObj.surveyParamaters.postPresentation,
  };
  if (dereferencedObj.surveyParamaters.studyInfo) {
    studyModel.respondentOrientation = dereferencedObj.surveyParamaters.studyInfo;
  }
  if (dereferencedObj.surveyParamaters.ratingQuestions) {
    studyModel.ratingQuestions = dereferencedObj.surveyParamaters.ratingQuestions;
  }
  if (dereferencedObj.surveyParamaters.maxRating) {
    studyModel.maxRating = dereferencedObj.surveyParamaters.maxRating;
  }
  if (dereferencedObj.studyPurpose) {
    studyModel.finalThoughts = dereferencedObj.studyPurpose;
  }
  if (dereferencedObj.tags) {
    studyModel.keywords = dereferencedObj.tags.map((tagObj) => {
      return tagObj.keyword;
    });
  }
  if (dereferencedObj.hidden) {
    studyModel.serviceType = RADIO_BUTTON_VALUE_STANDARD_SERVICE;
  }
  if (dereferencedObj.sourcingMethod) {
    studyModel.sourcingMethod = dereferencedObj.sourcingMethod;
  }
  if (dereferencedObj.maxParticipants) {
    studyModel.maxParticipants = dereferencedObj.maxParticipants;
  }
  if (dereferencedObj.published) {
    studyModel.published = dereferencedObj.published;
  }
  if (dereferencedObj.student) {
    studyModel.student = dereferencedObj.student;
  }
  if (dereferencedObj.paidParticipants) {
    studyModel.paidParticipants = dereferencedObj.paidParticipants;
  }
  if (dereferencedObj.paidLucidParticipants) {
    studyModel.paidLucidParticipants = dereferencedObj.paidLucidParticipants;
  }
  return studyModel;
};

const selectedQualificationsModel = () => {
  return {
    countryLanguageID: 9,
    qualifications: [],
    quota: -1,
    studyID: -1,
  };
};

const formatDate = (date) => {
  let months = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "Apr",
    4: "May",
    5: "Jun",
    6: "Jul",
    7: "Aug",
    8: "Sep",
    9: "Oct",
    10: "Nov",
    11: "Dec",
  };
  let month = months[date.getMonth()];
  let day = date.getDate();
  let year = date.getFullYear();
  let formattedBirthday = `${month} ${day}, ${year}`;
  return formattedBirthday;
};

const formatBirthday = (date) => {
  let months = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "Apr",
    4: "May",
    5: "Jun",
    6: "Jul",
    7: "Aug",
    8: "Sep",
    9: "Oct",
    10: "Nov",
    11: "Dec",
  };
  let month = months[date.getMonth()];
  let day = date.getDate();
  let year = date.getFullYear();
  let formattedBirthday = `${month} ${day}, ${year} 12:00:00 AM`;
  return formattedBirthday;
};

const ideaCoachConstructor = () => ({
  currentStep: 1,
  suggestions: [],
  description: "",
  formStep: 1,
});

const numberToEnglish = (n) => {
  let str = "";
  switch (n) {
    case 4:
      str += "four";
      break;
    case 6:
      str += "six";
      break;
  }
  return str;
};

const studyModelFactory = (studyMode) => {
  const answerTemplate = {
    text: "",
  };
  const questionTemplate = {
    text: "",
    answers: [],
  };

  let modeDimensions = String(studyMode).split("x");
  if (modeDimensions.length < 2) {
    console.warn(`Study Mode: ${studyMode} is malformatted`);
    modeDimensions = ["4", "4"];
  }
  const studyMode0 = Number(modeDimensions[0]);
  const studyMode1 = Number(modeDimensions[1]);
  const questions = [];
  for (let i = 0; i < studyMode0; i++) {
    const question = Object.assign({}, questionTemplate);
    question.answers = [];
    for (let j = 0; j < studyMode1; j++) {
      const answer = Object.assign({}, answerTemplate);
      question.answers.push(answer);
    }
    questions.push(question);
  }

  const studyTemplate = {
    meta: {
      gridMode: studyMode,
      id: -1,
    },
    name: "",
    language: "",
    agreedToTerms: false,
    questions: questions,
    additionalClassificationQuestion: {
      question: {
        text: "",
      },
      answers: [
        {
          text: "",
        },
        {
          text: "",
        },
        {
          text: "",
        },
        {
          text: "",
        },
      ],
    },
    segmentQuestions: [],
    rejectRespondentIdQuestion: false,
    openEndedQuestion: "",
    preOptionalQuestion: "",
    presentationMedia: null,
    postPresentationMedia: null,
    respondentOrientation: "",
    ratingQuestions: [],
    maxRating: -1,
    finalThoughts: "",
    keywords: [],
    serviceType: RADIO_BUTTON_VALUE_STANDARD_SERVICE,
    sourcingMethod: null,
    agreeToTermsFinal: false,
    maxParticipants: -1,
    published: false,
    student: null,
    paidParticipants: 0,
    paidLucidParticipants: 0,
  };
  return studyTemplate;
};
export {
  debounce,
  studyModelFactory,
  incomingStudyMapper,
  numberToEnglish,
  deepCloneObj,
  formatBirthday,
  formatDate,
  selectedQualificationsModel,
  ideaCoachConstructor,
};
const exportObj = {
  debounce,
};
export default exportObj;
